import { forwardRef } from 'react';
import { type AriaDropDownProps } from './common';

interface Props {
  id: string;
  className: string;
  onClick: (e: React.UIEvent) => void;
  dropDownAria: AriaDropDownProps;
  ariaLabel: string;
  children: React.ReactNode;
  index: number;
  onArrowKey: (newIndex: number) => void;
  onExit: () => void;
}

const DropDownOption = function DropDownOption(
  props: Props,
  ref: React.ForwardedRef<HTMLDivElement>
) {
  const { dropDownAria, ariaLabel, className, id, onClick, children, onArrowKey, index, onExit } =
    props;
  const selected = dropDownAria.activeDescendantId === id;
  const onKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' || e.key === ' ') {
      onClick(e as React.UIEvent);
    }
    if (e.key === 'ArrowUp' || e.key === 'ArrowLeft') {
      onArrowKey(index - 1);
    }
    if (e.key === 'ArrowDown' || e.key === 'ArrowRight') {
      onArrowKey(index + 1);
    }
    if (e.key === 'Escape') {
      onExit();
    }
  };

  return (
    <div
      id={id}
      className={`${className} ${selected && 'active'}`}
      tabIndex={0}
      onClick={onClick}
      onKeyDown={onKeyDown}
      role="option"
      aria-selected={selected}
      aria-label={ariaLabel}
      ref={ref}
    >
      {children}
    </div>
  );
};

export default forwardRef<HTMLDivElement, Props>(DropDownOption);
